import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchInsertMaterial } from "./learningAPI";
import swal from "sweetalert";
export interface InsertMaterialState {
  insertMaterial: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: InsertMaterialState = {
  insertMaterial: [],
  status: "idle",
};

export const GetInsertMaterial = createAsyncThunk(
  "InsertMaterial/fetchInsertMaterial",
  async (data: any) => {
    const response = await fetchInsertMaterial(data);
    return response;
  }
);

export const InsertMaterialSlice = createSlice({
  name: "InsertMaterial",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetInsertMaterial.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetInsertMaterial.rejected, (state) => {
        state.status = "failed";
        swal("Something went wrong!", "error");
      })
      .addCase(GetInsertMaterial.fulfilled, (state, action) => {
        state.status = "idle";
        state.insertMaterial = action.payload;
        swal("Record saved success!", "success");
      });
  },
});

export const {} = InsertMaterialSlice.actions;

export const selectInsertMaterial = (state: RootState) => {
  return state.InsertMaterial.insertMaterial;
};

export default InsertMaterialSlice.reducer;
